<template>
    <div id="coach-demographic">
        <div class="panel-coach-demographic">
            <h2 class="page-header">Wat voor coach zoek je?</h2>
            <label class="label-header">Ik heb het liefst een:</label>
            <div class="input-container" id="coach-age">

                    <div class="radio-container">
                        <div class="radio-wrapper"><label><input type="radio" value="Een coach die ouder is" v-model="answer.coachAge"><span class="tick">Een coach die ouder is</span></label></div>
                        <div class="radio-wrapper"><label><input type="radio" value="Een coach die jonger is" v-model="answer.coachAge"><span class="tick">Een coach die jonger is</span></label></div>
                        <div class="radio-wrapper"><label><input type="radio" value="Een coach die even oud is" v-model="answer.coachAge"><span class="tick">Een coach die even oud is</span></label></div>
                        <div class="radio-wrapper"><label><input type="radio" value="Leeftijd maakt mij niet uit" v-model="answer.coachAge"><span class="tick">Maakt mij niet uit</span></label></div>
                    </div>

            </div>

            <div class="input-container" id="coach-age-difference" v-if="showDate">
                <div class="panel-age-difference">
                    <label class="label-header">Wat is je geboortedatum?</label>
                    <div class="panel-text-container">
                        <p>Zodat we je aan de juiste coaches kunnen matchen.</p>
                    </div>
                    <div class="input-container radio-container">
                        <div v-if="safari" class="radio-wrapper">
                            <div class="date-text-field"><label><input type="radio" value="datum" v-model="answer.date"><span class="tick tick-input"><input type="text" placeholder="dd-mm-jjjj" ref="birthdate" v-model="answer.birthday" @focus="answer.date = 'datum'"></span></label></div>
                        </div>
                        <div v-else class="radio-wrapper">
                            <div class="date-field"><label><input type="radio" value="datum" v-model="answer.date"><span class="tick tick-input"><input type="date" ref="birthdate" v-model="answer.birthday" @focus="answer.date = 'datum'"></span></label></div>
                        </div>

                        <div class="radio-wrapper"><label><input type="radio" value="geen" v-model="answer.date"><span class="tick">Zeg ik liever niet</span></label></div>
                    </div>
                </div>
            </div>

            <div class="input-container" v-if="showAgeGroups" id="seeker-agegroup">
                <div class="panel-coach-age">
                    <label class="label-header">Onder welke leeftijdscategorie val je?</label>

                        <div class="radio-container">
                            <div class="radio-wrapper"><label><input type="radio" value="Ik ben jonger dan twintig" v-model="answer.age"><span class="tick">Ik ben jonger dan twintig</span></label></div>
                            <div class="radio-wrapper"><label><input type="radio" value="Ik ben een twintiger" v-model="answer.age"><span class="tick">Ik ben een twintiger</span></label></div>
                            <div class="radio-wrapper"><label><input type="radio" value="Ik ben een dertiger" v-model="answer.age"><span class="tick">Ik ben een dertiger</span></label></div>
                            <div class="radio-wrapper"><label><input type="radio" value="Ik ben een veertiger" v-model="answer.age"><span class="tick">Ik ben een veertiger</span></label></div>
                            <div class="radio-wrapper"><label><input type="radio" value="Ik ben een vijftiger" v-model="answer.age"><span class="tick">Ik ben vijftiger</span></label></div>
                            <div class="radio-wrapper"><label><input type="radio" value="Ik ben 65+" v-model="answer.age"><span class="tick">Ik ben 65+</span></label></div>
                        </div>

                </div>
            </div>

            <label class="label-header">Ik heb het liefst een:</label>
            <div class="input-container" id="coach-gender">

                    <div class="radio-container">
                        <div class="radio-wrapper"><label><input type="radio" value="mannen" v-model="answer.gender"><span class="tick">Man</span></label></div>
                        <div class="radio-wrapper"><label><input type="radio" value="vrouwen" v-model="answer.gender"><span class="tick">Vrouw</span></label></div>
                        <div class="radio-wrapper"><label><input type="radio" value="Geslacht maakt mij niet uit" v-model="answer.gender"><span class="tick">Maakt mij niet uit</span></label></div>
                    </div>

            </div>

            <label class="label-header">Ik word het liefst gecoacht in het:</label>
            <div class="input-container" id="coach-lang">
                <div class="radio-wrapper" v-for="lang in languages" :key="lang.id">
                  <label>
                    <input type="radio" :value="lang.id" v-model="answer.language">
                    <span class="tick">{{ lang.title }}</span>
                  </label>
                </div>

                <div class="radio-wrapper">
                    <label>
                      <input type="radio" value="Maakt mij niet uit" v-model="answer.language">
                      <span class="tick">Maakt mij niet uit</span>
                    </label>
                </div>
            </div>

            <div class="buttons-container">
                <previous-button />
                <next-button :isValid="this.isAnswered.coachAge && allValid" />
            </div>
				</div>
    </div>
</template>
<script>
    import PreviousButton from "../partials/PreviousButton";
    import NextButton from "../partials/NextButton";

    export default {
        name: "Demographic",
        components: {
            NextButton,
            PreviousButton
        },
        props: {
            isValid: {
                type: Function
            },
            answer: {
                type: Object
            },
            invalid: {
                type: Object
            },
            isAnswered: {
                type: Object
            }
        },
        computed: {
            showDate() {
                let showDate = this.answer.coachAge !== "Leeftijd maakt mij niet uit"

                if (!showDate) {
                    this.answer.date = null;
                }

                return showDate
            },

            showAgeGroups() {
                let showAgeGroups = this.showDate && this.answer.date === "geen"

                if (!showAgeGroups) {
                    this.answer.age = null;
                }

                return showAgeGroups
            },

            dateFieldSelected() {
                let dateSelected = this.answer.date === "datum"

                return dateSelected
            },

            allValid() {
                let validDate = true;
                let validAge = true;
                let validBirthday = true;

                if (this.showDate) {
                    validDate = this.isValid('date')
                }

                if (this.showAgeGroups) {
                    validAge = this.isValid('age')
                }

                if (this.dateFieldSelected) {
                    validBirthday = this.isValid('birthday')
                }

                return this.isValid('coachAge')
                && this.isValid('gender')
                && this.isValid('language')
                && validDate
                && validAge
                && validBirthday
            }
        },
        created() {
            this.$emit('setRules', this.rules)
            this.safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        },
        data() {
            return {
                safari: false,
                languages: languages,
                rules: {
                    coachAge: {
                        required: true
                    },
                    gender: {
                        required: true
                    },
                    date: {
                        required: true
                    },
                    age: {
                        required: true
                    },
                    birthday: {
                        birthday: true
                    },
                    language: {
                        required: true
                    }
                }
            }
        }
    }
</script>